<div id='sgl-container' [style.width]="width + 'px'" [style.height]="height + 'px'">
    <div id='sgl-1' [ngClass]="{ 'sgl-filled': currentLevel > 0, 'sgl-empty': true }"></div>
    <div id='sgl-2' [ngClass]="{ 'sgl-filled': currentLevel > 2, 'sgl-empty': true }"></div>
    <div id='sgl-3' [ngClass]="{ 'sgl-filled': currentLevel > 4, 'sgl-empty': true }"></div>
    <div id='sgl-4' [ngClass]="{ 'sgl-filled': currentLevel > 6, 'sgl-empty': true }"></div>
    <div id='sgl-5' [ngClass]="{ 'sgl-filled': currentLevel > 8, 'sgl-empty': true }"></div>
</div>